import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import ChartTitle from '../atoms/ChartTitle'
import Note from '../atoms/Note'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch; /* allow ChartTitle to take full width and align left */
  margin: 2rem 0;
  width: 100%;
`

const Img = styled.img`
  width: 100%;
  max-width: 960px;
  height: auto;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  margin: 0 auto; /* keep image centered while title is left-aligned */
`

const Inner = styled.div`
  width: 100%;
  max-width: 960px; /* match image max-width */
  margin: 0 auto; /* center to match image */
`

const CanvaImage = ({ src, caption, alt, note }) => {
  // read titles/config from public/const.js like other components
  const $ = typeof window !== 'undefined' ? window.WILDLABS_VARS : null
  const titleFromConst =
    ($ && ($.canva_titles?.chartTitle || $.canva_titles?.title)) ||
    $.canva_title ||
    null

  return (
    <Wrapper>
      {titleFromConst && (
        <Inner>
          <ChartTitle text={titleFromConst}>
            {/* no children for now, but keeps same structure as other charts */}
          </ChartTitle>
        </Inner>
      )}
      <Img src={src} alt={alt || caption || 'Canva graphic'} />
      {note && <Note note={note} type={'tech'} />}
    </Wrapper>
  )
}

CanvaImage.propTypes = {
  src: PropTypes.string.isRequired,
  caption: PropTypes.string,
  alt: PropTypes.string,
  note: PropTypes.string
}

export default CanvaImage
